import { ApplicationState } from "../../../ApplicationState.types";

const OPEN_BETS_BADGE_THRESHOLD = 99;

export const formatOpenBetsBadge = (count: number): string | undefined => {
  if (count <= 0) return;

  return count > OPEN_BETS_BADGE_THRESHOLD ? `${OPEN_BETS_BADGE_THRESHOLD}+` : String(count);
};

export const getOpenBetsCount = (state: ApplicationState): number => state.activeBetCount?.count ?? 0;
